import { Link } from "react-router-dom";
import { config } from "../pages/config";
import FooterBg from "../../assets/images/Reviews.jpg"

const CTASection = () => {
    return(
        <section className="testimonial-section" style={{ padding: "80px 0px" }}>
            <div className="bg-layer footer-layer" style={{ backgroundImage: `url(${FooterBg})`, border: "1px solid white" }}></div>
            <div className="auto-container">
                <div className="row clearfix">
                    <div className="col-lg-6 col-md-12 col-sm-12 title-column">
                        <div className="title-inner">
                            <div className=" light">
                                <h3 className='text-white'>Become an expert driver and gain confidence on the road </h3>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6 title-inner text-md-end'>
                        <div className="review-box">
                            <Link to={`${config.appUrl}get-started`} className="theme-btn btn-two">Get started Now</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CTASection;